// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/pdf/fondo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
}

.grid-header {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.grid-item-header {
  justify-self: center;
}

.social-networks {
  display: flex;
}

.contact {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.contact-links {
  display: flex;
}

.email {
  display: flex;
  margin-right: 1rem;
  align-items: center;
}

.phone {
  display: flex;
  align-items: center;
}

.address {
  display: flex;
  margin-top: 5px;
}

.address p {
  font-weight: 500;
}

.grid-table {
  margin-top: 5rem;
  display: flex;
  justify-content: center;
}

.grid-price {
  margin-top: 2rem;
  padding-right: 12rem;
  display: flex;
  justify-content: end;
}

.grid-price-list {
  display: flex;
  flex-direction: column;
}

.grid-price span {
  font-weight: 600;
}

.grid-price p {
  margin-bottom: 10px;
}

.grid-alert {
  display: flex;
  margin-top: 5rem;
  justify-content: center;
}

.alert {
  display: flex;
  align-items: center;
  background-color: #BEE4F6;
  padding: 8px 30px;
}

.container-table {
  width: 80%;
  border: 1px solid #B9B9B9;
  border-radius: 24px;
  padding: 1rem;
}

table {
  width: 100%;
}

.init-row-img {
  width: 100%;
  margin-top: 10px;
}

.row-img {
  display: flex;
  justify-content: center;
}

td {
  text-align: center;
}

.grid-footer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: end;
}

.content-footer {
  width: 100%;
  height: 60px;
  display: flex;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  justify-content: end;
  padding-right: 2.5rem;
}

.grid-footer p {
  line-height: 1.2;
}

.grid-footer a {
  text-decoration: underline;
  color: #2D70A7;
}

@media (max-width: 1121px) {
  .container {
    display: none;
  }
}
@media (min-width: 1122px) {
  .container-mb {
    display: none;
  }
}
.container-mb {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
}

.grid-header-mb {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
}

.grid-item-header-mb {
  justify-self: center;
}

.contact-links-mb {
  display: flex;
  flex-direction: column;
  padding-top: 2rem;
}

.email-mb {
  display: flex;
  justify-content: center;
}

.phone-mb {
  display: flex;
  justify-content: center;
}

.address-mb {
  margin-top: 1rem;
  text-align: center;
}

.grid-table-mb {
  margin-top: 2rem;
  display: flex;
  width: 100%;
  justify-content: center;
}

.grid-cards-mb {
  display: flex;
  width: 90%;
  flex-direction: column;
}

.card-mb {
  border: 1px solid #D9D9D9;
  padding: 5px;
  width: 100%;
  display: grid;
  grid-template-columns: 2fr;
  grid-template-rows: 1fr;
  grid-template-areas: "img_card data_card";
}

.card-mb .img_card {
  grid-area: img_card;
}

.card-mb .data_card {
  padding-top: 5px;
  grid-area: data_card;
  line-height: 1.2;
  text-align: end;
}

.product-quantity {
  font-size: 14px;
  color: #828282;
}

.data_card p {
  font-weight: 600;
}

.grid-price-mb {
  display: flex;
  margin-top: 2rem;
  padding-left: 20px;
}

.grid-price-list-mb {
  line-height: 1.2;
}

.grid-price-list-mb span {
  font-weight: 600;
}

.grid-alert-mb {
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  background-color: #BEE4F6;
  padding-top: 10px;
  padding-bottom: 10px;
}

.alert-mb {
  display: flex;
  text-align: center;
}

.content-footer-mb {
  padding: 5px;
  margin-top: 2rem;
  margin-bottom: 2rem;
  text-align: center;
  line-height: 1.2;
}

.content-footer-mb a {
  color: #2D70A7;
}`, "",{"version":3,"sources":["webpack://./src/pages/PDFQuoteProducts/styled.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;AACJ;;AAEA;EACI,aAAA;EACA,qCAAA;AACJ;;AAEA;EACI,oBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,eAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,aAAA;EACA,uBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,oBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAGA;EACI,aAAA;EACA,gBAAA;EACA,uBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ;;AAGA;EACI,WAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,uBAAA;AAAJ;;AAGA;EACI,kBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,yDAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;;AAGA;EACI,0BAAA;EACA,cAAA;AAAJ;;AAGA;EACI;IACI,aAAA;EAAN;AACF;AAGA;EACI;IACI,aAAA;EADN;AACF;AAIA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;AAFJ;;AAKA;EACI,aAAA;EACA,qCAAA;AAFJ;;AAKA;EACI,oBAAA;AAFJ;;AAKA;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;AAFJ;;AAKA;EACI,aAAA;EACA,uBAAA;AAFJ;;AAKA;EACI,aAAA;EACA,uBAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;AAFJ;;AAKA;EACI,aAAA;EACA,UAAA;EACA,sBAAA;AAFJ;;AAKA;EACI,yBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,0BAAA;EACA,uBAAA;EACA,yCACI;AAHR;;AAOA;EACI,mBAAA;AAJJ;;AAOA;EACI,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;AAJJ;;AAOA;EACI,eAAA;EACA,cAAA;AAJJ;;AAOA;EACI,gBAAA;AAJJ;;AAOA;EACI,aAAA;EACA,gBAAA;EACA,kBAAA;AAJJ;;AAOA;EACI,gBAAA;AAJJ;;AAOA;EACI,gBAAA;AAJJ;;AAOA;EACI,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,iBAAA;EACA,oBAAA;AAJJ;;AAOA;EACI,aAAA;EACA,kBAAA;AAJJ;;AAOA;EACI,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,cAAA;AAJJ","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100vh;\n}\n\n.grid-header {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n}\n\n.grid-item-header {\n    justify-self: center;\n}\n\n.social-networks {\n    display: flex;\n}\n\n.contact {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.contact-links {\n    display: flex;\n}\n\n.email {\n    display: flex;\n    margin-right: 1rem;\n    align-items: center;\n}\n\n.phone {\n    display: flex;\n    align-items: center;\n}\n\n.address {\n    display: flex;\n    margin-top: 5px;\n}\n\n.address p {\n    font-weight: 500;\n}\n\n.grid-table {\n    margin-top: 5rem;\n    display: flex;\n    justify-content: center;\n}\n\n.grid-price {\n    margin-top: 2rem;\n    padding-right: 12rem;\n    display: flex;\n    justify-content: end;\n}\n\n.grid-price-list {\n    display: flex;\n    flex-direction: column;\n}\n\n.grid-price span {\n    font-weight: 600;\n}\n\n.grid-price p {\n    margin-bottom: 10px;\n}\n\n\n.grid-alert {\n    display: flex;\n    margin-top: 5rem;\n    justify-content: center;\n}\n\n.alert {\n    display: flex;\n    align-items: center;\n    background-color: #BEE4F6;\n    padding: 8px 30px;\n}\n\n.container-table {\n    width: 80%;\n    border: 1px solid #B9B9B9;\n    border-radius: 24px;\n    padding: 1rem;\n}\n\ntable {\n    width: 100%;\n}\n\n.init-row-img {\n    width: 100%;\n    margin-top: 10px;\n}\n\n.row-img {\n    display: flex;\n    justify-content: center;\n}\n\ntd {\n    text-align: center;\n}\n\n.grid-footer {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: end;\n}\n\n.content-footer {\n    width: 100%;\n    height: 60px;\n    display: flex;\n    background-image: url('../../assets/images/pdf/fondo.png');\n    background-size: cover;\n    justify-content: end;\n    padding-right: 2.5rem;\n}\n\n.grid-footer p {\n    line-height: 1.2;\n}\n\n.grid-footer a {\n    text-decoration: underline;\n    color: #2D70A7;\n}\n\n@media (max-width: 1121px) {\n    .container {\n        display: none;\n    }\n}\n\n@media (min-width: 1122px) {\n    .container-mb {\n        display: none;\n    }\n}\n\n.container-mb {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100vh;\n}\n\n.grid-header-mb {\n    display: grid;\n    grid-template-columns: repeat(1, 1fr);\n}\n\n.grid-item-header-mb {\n    justify-self: center;\n}\n\n.contact-links-mb {\n    display: flex;\n    flex-direction: column;\n    padding-top: 2rem;\n}\n\n.email-mb {\n    display: flex;\n    justify-content: center;\n}\n\n.phone-mb {\n    display: flex;\n    justify-content: center;\n}\n\n.address-mb {\n    margin-top: 1rem;\n    text-align: center;\n}\n\n.grid-table-mb {\n    margin-top: 2rem;\n    display: flex;\n    width: 100%;\n    justify-content: center;\n}\n\n.grid-cards-mb {\n    display: flex;\n    width: 90%;\n    flex-direction: column;\n}\n\n.card-mb {\n    border: 1px solid #D9D9D9;\n    padding: 5px;\n    width: 100%;\n    display: grid;\n    grid-template-columns: 2fr;\n    grid-template-rows: 1fr;\n    grid-template-areas:\n        \"img_card data_card\"\n    ;\n}\n\n.card-mb .img_card {\n    grid-area: img_card;\n}\n\n.card-mb .data_card {\n    padding-top: 5px;\n    grid-area: data_card;\n    line-height: 1.2;\n    text-align: end;\n}\n\n.product-quantity {\n    font-size: 14px;\n    color: #828282;\n}\n\n.data_card p {\n    font-weight: 600;\n}\n\n.grid-price-mb {\n    display: flex;\n    margin-top: 2rem;\n    padding-left: 20px;\n}\n\n.grid-price-list-mb {\n    line-height: 1.2;\n}\n\n.grid-price-list-mb span {\n    font-weight: 600;\n}\n\n.grid-alert-mb {\n    margin-top: 2rem;\n    display: flex;\n    justify-content: center;\n    background-color: #BEE4F6;\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n\n.alert-mb {\n    display: flex;\n    text-align: center;\n}\n\n.content-footer-mb {\n    padding: 5px;\n    margin-top: 2rem;\n    margin-bottom: 2rem;\n    text-align: center;\n    line-height: 1.2;\n}\n\n.content-footer-mb a {\n    color: #2D70A7;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
